<template>
    <select :value="addressData.gender" data-testing="salutation-select" class="custom-select salutation-select" :class="'salutation-select-' + addressType"
            @change="emitInputEvent($event.target.value)" data-autofocus>
        <option :value="salutation.key"
                :data-publicfacility="salutation.isPublicFacility"
                :selected="addressData.gender === salutation.key && checkGenderCompany(salutation.key)" :key="index"
                v-for="(salutation, index) in currentSalutation">
            {{ salutation.name }}
        </option>
    </select>
</template>

<script>
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {

    name: "salutation-select",

    props:
    {
        addressData:
        {
            type: Object,
            required: true
        },
        addressType:
        {
            type: [Number, String],
            default: 1
        },
        enabledAddressFields:
        {
            type: Object,
            default: () => []
        },
        defaultSalutation: {
            type: String,
            default: "company"
        }
    },

    data()
    {
        return {
            salutations: [
                {
                    key: "diverse",
                    name: "addressSalutationDiverse",
                    isPublicFacility: "no"
                },
                {
                    key: "company",
                    name: "addressSalutationCompany",
                    isPublicFacility: "no"
                },
                {
                    key: "public_facility",
                    name: "addressSalutationPublicFacility",
                    isPublicFacility: "yes"
                }
            ]
        };
    },

    computed:
    {
        currentSalutation()
        {
            const countryId = parseInt(this.addressData.countryId) || 1;
            const addressKey = parseInt(this.addressType) === 1 ? "billing_address" : "delivery_address";
            const countryKey = countryId === 12 ? "gb" : "de";

            const salutations = this.salutations.map(salutation =>
            {
                return {
                    key: salutation.key,
                    name: salutation.name !== "addressSalutationPublicFacility" ? this.$translate("Ceres::Template." + salutation.name) : this.$translate("AbfallbehaelterXXL::Template." + salutation.name),
                    isPublicFacility: salutation.isPublicFacility+""
                };
            });

            if (this.enabledAddressFields[countryKey].includes(`${addressKey}.name1`))
            {
                return salutations;
            }

            return salutations.filter(salutation => salutation.key !== "company");
        }
    },

    /**
     * Get the shipping countries
     */
    created()
    {
        this.$options.template = this.template;

        let selectedSalutation = this.defaultSalutation;

        if((App.customer != null && App.customerClass == 4) || (typeof sessionStorage.getItem('isPublicFacility') !== "null" && sessionStorage.getItem('isPublicFacility') == "1")){
            selectedSalutation = "public_facility";
        }

        if (isNullOrUndefined(selectedSalutation))
        {
            selectedSalutation = this.currentSalutation[0].key;
        }

        this.emitInputEvent(selectedSalutation);
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            if(App.customer != null && App.customerClass == 4){
                let selectedSalutation = "public_facility";
                this.emitInputEvent(selectedSalutation);
            }
        })
    },

    methods:
    {
        emitInputEvent(value)
        {
            const isNewGenderPersonal = this.getIsGenderPersonal(value)
            const isOldGenderPersonal = this.getIsGenderPersonal(this.addressData.gender)

            this.$emit("input", { field: "gender", value: value });

            // just reset the input fields, when switching the gender between a personal one and company
            if (isNewGenderPersonal !== isOldGenderPersonal)
            {
                this.$emit("input", { field: "name1", value: "" });
                this.$emit("input", { field: "name2", value: "" });
                this.$emit("input", { field: "name3", value: "" });
                this.$emit("input", { field: "vatNumber", value: "" });
                this.$emit("input", { field: "contactPerson", value: "" });
            }
        },

        checkGenderCompany(gender)
        {
            if (gender === "company")
            {
                return (this.addressData.name1 !== null) || (this.addressData.name1 !== "");
            }
            return true;
        },

        getIsGenderPersonal(gender)
        {
            return ["male", "female", "diverse"].includes(gender);
        }
    },

    watch:
    {
        currentSalutation(newVal, oldVal)
        {
            if (newVal !== oldVal)
            {
                const selectedSalutation = this.addressData.gender;

                // cleanse the current selected salutation, if it's not longer included in the choice
                if (!newVal.map(salutation => salutation.key).includes(selectedSalutation))
                {
                    this.emitInputEvent(newVal[0].key);
                }
            }
        }
    }
}
</script>
